import React from 'react'
import { useEffect, useState } from 'react';
import './ComponentsCss/NewsItem.css';
// imgs 
import img1 from '../imgs/bigImgs/pic1.jpg';
import ProfileImgs from '../imgs/NewsListImgs/profile.png';
import bgImg from '../imgs/NewsListImgs/background.png'
// axios 
import axios from 'axios';

const NewsItemGallery = ({ mainImgSrc, title, lawyerId, deadline, jointNo, goalSupp }) => {
    const [supprtPerc, SetSupportPerc] = useState(0);
    const [deadlineDiff, SetDeadlineDiff] = useState(0);

    const [LawyerData, SetLawyerData] = useState();
    useEffect(() => {
        if(goalSupp == 0 ) {
            SetSupportPerc(0);     
        }else{
            SetSupportPerc((jointNo / goalSupp) * 100);
        }
        
        // axiosLawyerData();
        SetDeadlineDiff(getDateDiff(deadline));
        axiosLawyerData();
    }, []);

    function getDateDiff(deadline) {
        let date = (new Date(deadline)).getTime();
        let today = (new Date()).getTime();
        let msDay = 24 * 60 * 60 * 1000; // milliseconds per day

        let days = Math.floor((date - today) / msDay);
        return days;
    }
    const axiosLawyerData = async () => {
        //console.log(" axiosLawyerData ");
        const controller = new AbortController();
        var finalIP = "";
        // https://stepupkorea.kr/api/NewsList/getAllNews
        finalIP = "https://stepupkorea.kr/api/Lawyer/lawyerData";
        try {
            const response = await axios.get(finalIP
                , {
                    signal: controller.signal,
                    params: {
                        lawyerId: lawyerId
                    }
                }
            );
            if (response) {
                //console.log(response.data);
                SetLawyerData(response.data);
                //SetNewsListsArray(response.data);
            } else {

            }

        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Missing Username or Password');
            } else if (err.response?.status === 401) {
                console.log('--Unauthorized');
            } else {
                console.log('ERR');
            }

        }
    }
    return (
        <div className="content-container">
            <div className="content-box">

                <div className="project-card">
                    <div className="banner-section">
                        <img
                            src={"https://stepupkorea.kr/images/news-lists/main/" + mainImgSrc}
                            className="project-image"
                            alt="프로젝트 이미지"
                        />
                    </div>
                    <div className="bottom-line"></div>
                    <div className="project-info">
                        {LawyerData ?
                            <>
                                <img
                                    src={"https://stepupkorea.kr/images/lawyers/" + LawyerData[0]?.lawyerImage}
                                    className="profile-icon"
                                    alt="프로필 아이콘"
                                />
                                <div className="text-content">
                                    <h2 className="case-title">{title}</h2>
                                    <p className="case-laywer">{LawyerData[0]?.lawyerName} 변호사 </p>
                                    <div className="case-info">
                                        <span>🕒</span>
                                        <span className="due-date">{deadlineDiff}</span>
                                        <span>일 남음</span>
                                        <span> · </span>
                                        <span className="percent">{supprtPerc.toLocaleString(undefined, { maximumFractionDigits: 0 })} %</span>
                                        <span>달성함</span>
                                    </div>
                                </div>
                            </>
                            :
                            null}

                    </div>
                </div>

            </div>
        </div>
    )
}

export default NewsItemGallery